import React from 'react';
import { bool, object, shape, string } from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { getContext } from '@fiverr-private/fiverr_context';
import SafePureComponent from '../shared/SafePureComponent';
import { shouldRenderCustomOrder } from '../../common/customOrder';
import isInCustomOrderPackageTest from '../../utils/experiments/customOrderPackage';
import isInContactSellerOptionsTest from '../../utils/experiments/contactSellerOptions';
import { isSinglePackage } from '../../reducers/packages';
import CustomOrder from './CustomOrder';
import ContactSellerBtn from './ContactSellerBtn';
import ContactSellerOptions from './ContactSellerOptions';

import './style.scss';

const ContactSeller = ({ customOrder, isSinglePackage }, { general }) => {
    const { userId, abTests } = getContext();
    const { isOnVacation } = general;
    const inCustomOrderPackageTest = isInCustomOrderPackageTest(abTests);
    const inContactSellerOptionsTest = isInContactSellerOptionsTest(abTests);
    const customOrderEligible = shouldRenderCustomOrder({
        userId,
        customOrder,
        general,
        inCustomOrderPackageTest
    });

    const displayContactSellerOptions = customOrderEligible && inContactSellerOptionsTest;
    const shouldDisplayCustomOrder = customOrderEligible && !inContactSellerOptionsTest;
    const shouldDisplayContactSeller = !isOnVacation && !customOrderEligible;

    const wrapperClass = classNames('contact-seller', {
        'display-custom-order': shouldDisplayCustomOrder,
        'display-contact-seller': shouldDisplayContactSeller,
        'in-custom-order-package-test': inCustomOrderPackageTest,
        'single-package': isSinglePackage
    });

    return (
        <div className={wrapperClass}>
            {displayContactSellerOptions && <ContactSellerOptions/>}
            <CustomOrder titleKey="gig_page_perseus.custom_order.get_a_quote"/>
            <ContactSellerBtn titleKey="gig_page_perseus.contact_seller.title"/>
        </div>
    );
};

ContactSeller.propTypes = {
    customOrder: shape({
        currentUserStatus: string,
        allowCustomOrders: bool
    })
};

ContactSeller.defaultProps = {
    customOrder: {
        allowCustomOrders: true
    }
};

ContactSeller.contextTypes = {
    general: object
};

const mapStateToProps = ({ packages }) => ({
    isSinglePackage: isSinglePackage(packages)
});

export { ContactSeller };
export default SafePureComponent(connect(mapStateToProps)(ContactSeller));
